import { useContext } from 'react';
import Context from './Context';

export default function useMessageApi() {
  const { message } = useContext(Context);
  return message;
}
